import apiFetch from '../apiFetch'

export default function (idTransportista, token) {
  return apiFetch({endPoint: `Transportista/deleteTransporte`, method: 'POST', body: {idTransportista}, token: token})
}
